/**
 * Componente para la gestión integral de Categorías.
 * Permite crear, editar nombres y reordenar la jerarquía de las categorías
 * mediante drag-and-drop. Toda la lógica de guardado se delega al
 * AdminDataService.
 */
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AdminDataService } from '../../controller/admin-data.service';
import { CategorySyncItem } from '@solverml/api';

@Component({
  selector: 'app-category-management',
  standalone: true,
  imports: [CommonModule, FormsModule, DragDropModule],
  templateUrl: './category-management.component.html',
  styleUrls: ['../management-component.scss']
})
export class CategoryManagementComponent implements OnInit {

  public categories: CategorySyncItem[] = [];
  public newCategoryName: string = '';
  public isLoading: boolean = true;

  constructor(private adminDataService: AdminDataService) {}

  ngOnInit(): void {
    this.loadCategories();
  }

  /**
   * Carga la lista de categorías desde el backend y la prepara para el formulario.
   */
  loadCategories(): void {
    this.isLoading = true;
    this.adminDataService.getCategories().subscribe(data => {
      this.categories = data.map(c => ({ id: c.id, name: c.name }));
      this.isLoading = false;
    });
  }

  /**
   * Gestiona el evento de drag-and-drop para reordenar la lista local de categorías.
   */
  onDrop(event: CdkDragDrop<CategorySyncItem[]>): void {
    moveItemInArray(this.categories, event.previousIndex, event.currentIndex);
  }

  /**
   * Añade una nueva categoría a la lista local, para ser creada al guardar.
   */
  addCategory(): void {
    if (this.newCategoryName.trim()) {
      this.categories.push({ id: null, name: this.newCategoryName.trim() });
      this.newCategoryName = '';
    }
  }

  /**
   * Elimina una categoría de la lista local.
   * La eliminación definitiva ocurrirá en el backend si la categoría ya existía.
   * TODO: Aun está por implementar
   */
  removeCategory(index: number): void {
    this.categories.splice(index, 1);
  }

  /**
   * Envía la lista completa (con el nuevo orden, nombres y elementos) al backend
   * para que la sincronice.
   */
  saveChanges(): void {
    this.isLoading = true;
    this.adminDataService.syncCategories(this.categories).subscribe({
      next: (updatedCategories) => {
        this.categories = updatedCategories.map(c => ({ id: c.id, name: c.name }));
        this.isLoading = false;
        // añadir una notificación de éxito
      },
      error: (err) => {
        console.error("Error al sincronizar las categorías", err);
        this.isLoading = false;
      }
    });
  }
}
